import { Breadcrumbs } from "./breadcrumbs";
import { Button } from "@/components/ui/button";
import { Link } from "react-router";

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface PageLayoutProps {
  breadcrumbs: BreadcrumbItem[];
  children: React.ReactNode;
  showCta?: boolean;
}

export function PageLayout({ breadcrumbs, children, showCta = true }: PageLayoutProps) {
  return (
    <div className="py-12">
      <div className="max-w-[1120px] mx-auto px-6">
        <Breadcrumbs items={breadcrumbs} />
        {children}
        {showCta && (
          <div className="mt-16 bg-warm-lavender-bg border border-warm-lavender rounded-2xl py-12 px-8 text-center">
            <h2 className="text-2xl font-extrabold tracking-tight mb-3">Ready to add logos?</h2>
            <p className="text-sm text-secondary-foreground max-w-md mx-auto mb-6">
              Start fetching logos in under a minute. No API key required for the free tier.
            </p>
            <div className="flex gap-3 justify-center flex-wrap">
              <Button size="lg" asChild>
                <Link to="/#playground">Try the Playground</Link>
              </Button>
              <Button variant="outline" size="lg" asChild>
                <Link to="/docs">Read the Docs</Link>
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
